import { Box, Divider, Stack, Typography } from '@mui/material';
import AlertProvider from 'components/AlertProvider';
import AppProvider from 'components/AppProvider';
import Icon from 'components/Icon';
import { CartContext, CateringContext } from 'constants/contexts';
import dayjs from 'dayjs';
import React, { useContext } from 'react';

function MobileHeader({
  id,
  loading,
}) {
  const cart = useContext(CartContext);
  const catering = useContext(CateringContext);
  const hasError = !!cart.schedulingError;
  const alerts = AlertProvider.useAlerts(AlertProvider.POSITIONS.MDP);

  const isCollapsed = !AppProvider.useIsScrollAtTop();

  return (
    <Box
      style={{
        width: '100%',
        zIndex: 99,
        backgroundColor: '#fff',
        position: 'sticky',
        top: 64,
        transform: 'translate3d(0,0,0)',
      }}
      id={id}
    >
      {alerts}
      <Stack
        direction="row"
        spacing={1}
        sx={{ backgroundColor: 'background.elevation1', px: 2, py: 1.5 }}
        divider={<Divider orientation="vertical" flexItem/>}
      >
        <Stack spacing={0.5} width="65%" onClick={() => !loading && catering.openScheduling()}>
          <Stack direction="row" spacing={0.5} alignItems="center" display={isCollapsed ? 'none' : 'flex'}
                 color={hasError ? 'error.main' : 'inherit'}>
            <Icon name={`calendar-hour-${cart.scheduledTime ? 'filled' : 'outlined'}`}/>
            <Typography variant="label-sm" color={hasError ? 'error.main' : 'text.secondary'}>Date and Time</Typography>
          </Stack>
          <Stack direction="row" spacing={0.5} alignItems="center">
            {isCollapsed && <Icon name="calendar-hour-filled" color={hasError ? 'error.main' : 'inherit'}/>}
            {cart.scheduledTime ? (
              <Typography variant="body-md" color={hasError ? 'error.darker' : 'inherit'}>
                {dayjs(cart.scheduledTime).format('ddd, MMM DD · h:mm A')}
              </Typography>
            ) : (
              <>
                <Typography variant="body-md">
                  Select
                </Typography>
                <Icon name="arrow-right"/>
              </>
            )}
          </Stack>
        </Stack>

        <Stack spacing={0.5} onClick={catering.openHeadcount}>
          <Stack direction="row" spacing={0.5} alignItems="center" display={isCollapsed ? 'none' : 'flex'}>
            <Icon name={`user-group-${catering.headcount ? 'filled' : 'outlined'}`}/>
            <Typography variant="label-sm" color="text.secondary">Headcount</Typography>
          </Stack>
          <Stack direction="row" spacing={0.5} alignItems="center">
            {isCollapsed && <Icon name={`user-group-${catering.headcount ? 'filled' : 'outlined'}`}/>}
            {catering.headcount ? (
              <>
                <Typography
                  variant="body-md"
                >
                  {catering.headcount}
                </Typography>
                <Typography
                  variant="body-md"
                  color="text.secondary"
                >
                  people
                </Typography>
              </>
            ) : (
              <>
                <Typography variant="body-md">
                  Select
                </Typography>
                <Icon name="arrow-right"/>
              </>
            )}
          </Stack>
        </Stack>

      </Stack>
      {hasError && (
        <Stack bgcolor="background.error" p="8px 16px">
          <Typography variant="body-caption" color="error.darker">
            {cart.schedulingError}
          </Typography>
        </Stack>
      )}
    </Box>
  );
}

export default MobileHeader;
